import React, { useContext } from "react"

const TrackingContext = React.createContext()

const useTrackingContext = () => {
  const tracking = useContext(TrackingContext)
  return tracking
}

const TrackingProvider = props => {
  const url = new URL(props.canonicalUrl)

  return (
    <TrackingContext.Provider
      value={{
        sourcePagePath: url.pathname,
      }}
    >
      {props.children}
    </TrackingContext.Provider>
  )
}

export { TrackingProvider, useTrackingContext }
